import React, { useState, useEffect } from "react";
import { Container, Col, Row, Button, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Ripples from 'react-ripples';
import { apiUrl } from "../commons/inFormTypes";
import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Stations() {
    const [areaId, setAreaId] = useState(0);
    const [areaText, setAreaText] = useState("");
    const [seenFile, setSeenFile] = useState([]);
    const [areaList, setAreaList] = useState([]);
    const [locId, setLocId] = useState();
    const [title, setTitle] = useState();
    const [address, setAddress] = useState();
    const [stationID, setStationID] = useState();
    const navigate = useNavigate();
    const mstr = JSON.parse(localStorage.getItem("Master"));
    const userToken = localStorage.getItem("user_token");


    useEffect(() => {
        if (userToken == null) {
            navigate("/");
        } else {
            const axios = require("axios");
            axios
                .post(apiUrl + "Get_Liststation", {
                    AreaId: areaId,
                    TokenId:userToken,
                })

                .then((res) => {
                    if (res.data.result === "true") {
                        setSeenFile(res.data.data);
                        setAreaList(res.data.data_area)
                    } else {
                    }
                })
                .catch(function (error) {
                    if (error.response) {
                        toast.error(error.response.data.message, {
                            position: "top-center",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                });
        }
    }, [areaId]);

    const RadioHandlerChange = (val, title1, address1,stationID1) => {
        setLocId(val);
        setTitle(title1);
        setAddress(address1);
        setStationID(stationID1);
    }

    const submitHandler = () => {
        navigate('../finalinfo');
        mstr[0].stationTitle = title;
        mstr[0].stationAddress = address;
        mstr[0].stationId = stationID;
        localStorage.setItem("Master", JSON.stringify(mstr));
    }

    const selectAreaHandler = (e) => {
        setAreaId(e.target.value);
        setAreaText(e.target.options[e.target.selectedIndex].text);
      }

    return (
        <div>
            <Container>
                <Row className="justify-content-center mb-3">
                    <Col xs={11} lg={9} className="mt-3">
                        <Row className="justify-content-start gy-3 gx-5">

                            <Col xs={12} md={6}>
                                <div className="d-flex rgc-title pt-1">
                                    <div className="rgc-title-point"></div>
                                    <h4>لیست <span>ایستگاه های شهری تحویل زباله</span></h4>
                                </div>
                            </Col>

                            <Col xs={12} md={4} className="text-start me-auto">
                                <Form.Group>                               
                                    <Form.Select
                                        className="rgc-select"
                                        value={areaId}
                                        onChange={(e) => selectAreaHandler(e)}
                                    >
                                        <option key={0} value="0">
                                            انتخاب منطقه
                                        </option>
                                        {areaList.map((data, index) => (
                                            <option key={index} value={data.ParaCode}>
                                                {data.Title}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>


                            {seenFile.map((data, index) => {
                                return (                         
                                    <Col xs={12} md={6} key={index}>
                                        <Ripples className="rgc-ripple">
                                            <Row
                                                className={locId === data.Id.toString() ?
                                                    "justify-content-center rgc-driver-content rgc-station rgc-station-select"
                                                    : "justify-content-center rgc-driver-content rgc-station"}>
                                                <Col xs={2} className="rgc-ripple-icon">
                                                    <div className="radio">
                                                        <input
                                                            type="radio"
                                                            value={data.Id.toString()}
                                                            className="rgc-radio"
                                                            checked={locId === data.Id.toString()}
                                                            onChange={(e) => RadioHandlerChange(e.target.value, data.Name, data.Address,data.Id)}
                                                        />
                                                    </div>
                                                </Col>

                                                <Col xs={10} className="text-end">
                                                    <span>عنوان:</span>
                                                    <span>{data.Name}</span>
                                                </Col>

                                                <Col xs={8}>
                                                    <span>ساعت کاری:</span>
                                                    <span>{data.Hours}</span>
                                                </Col>

                                                <Col xs={8}>
                                                    <span>آدرس:</span>
                                                    <span>{data.Address}</span>
                                                </Col>
                                            </Row>
                                        </Ripples>
                                    </Col>
                                )
                            }
                            )
                            }
                    
                            <Col xs={12} className="text-center">
                                <Button className="rgc-orderreg-btn rgc-order-btn-sub" onClick={submitHandler} >
                                    مرحله بعد
                                </Button>
                            </Col>

                        </Row>
                    </Col>
                </Row>
            </Container >
            
        </div>
    )
}

export default Stations